import Owner from '@/generated/classes/Owner';
export default class OwnerExtend extends Owner {
  constructor() {
    super();
  }
}
